import React, { useState, useEffect } from 'react';
import {IbanElement, useElements, useStripe} from '@stripe/react-stripe-js';
import { addPaymentMethod } from '../../../actions/user-api';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import $ from 'jquery';
import * as R from 'ramda';

import { getSetupIntentByIdUrl } from '../../../constants/webapi/user';
import  *  as axios from 'axios';

export const AddVirementForm = ({ownerState, setOwnerState, formRef, user, formId, resetModal, setIsSaving, paymentMethod}) => {
    const toastConf = {position: toast.POSITION.TOP_RIGHT, autoClose:3000};
    let dispatch = useDispatch();
    const stripe = useStripe();
    const elements = useElements();
    const [setupIntent, setSetupIntent] = useState(undefined);

    const handleSubmit = async (event) => {

        event.preventDefault();
        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }
        setIsSaving(true);
        const ibanElement = elements.getElement(IbanElement);
        const result = await stripe.confirmSepaDebitSetup(setupIntent, {
            payment_method:{
                type: 'sepa_debit',
                sepa_debit: ibanElement,
                billing_details: ownerState
            }
          });
        if (result.error) {
            toast.error(result.error.message, toastConf);
        } else {
            await dispatch(addPaymentMethod(user, result.setupIntent.payment_method))
            .then(() => {
                setIsSaving(false);
                $('.modal').modal("hide");
                setSetupIntent(undefined);
                resetModal();
            });
        }
    }

    useEffect(() => {
        if(setupIntent === undefined){
            axios.get(getSetupIntentByIdUrl(user.id))
            .then((response) => {
                setSetupIntent(response.data);
            })
            .catch((error) => {
                console.log(error.response);
            });
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
    return (
        <form onSubmit={handleSubmit} ref={formRef} id={formId}>
            <div className="form-group">
                <label className="h6 font-weight-bolder my-auto" htmlFor="account-owner-name">Nom du titulaire du compte</label>
                <input type="text" name="accountholder-name" id="account-owner-name" className="form-control" placeholder="Jenny Rosen" value={ownerState.name} required onChange={
                    (e) => setOwnerState({ ...ownerState, name: e.target.value })
                }
                disabled={!R.isNil(paymentMethod)} />
            </div>
            <div className="form-group">
                <label className="h6 font-weight-bolder my-auto" htmlFor="account-owner-email">Email du titulaire du compte</label>
                <input type="email" name="accountholder-name" id="account-owner-email" className="form-control" placeholder="Jenny Rosen" value={ownerState.email} required onChange={
                    (e) => setOwnerState({ ...ownerState, email: e.target.value })
                }
                disabled={!R.isNil(paymentMethod)} />
            </div>
            {
                R.isNil(paymentMethod) ?
                    <div className="form-group">
                        <label className="h6 font-weight-bolder my-auto" htmlFor="account-iban">IBAN du compte</label>
                        <IbanElement
                            options={{
                                id: "account-iban",
                                style: {
                                    base: {
                                        color: '#26262e',
                                        lineHeight: '20px',
                                        fontSize: '16px',
                                        fontSmoothing: 'antialiased',
                                        '::placeholder': {
                                            color: '#9e9eac',
                                        },
                                    },
                                    invalid: {
                                        iconColor: '#B81412',
                                        color: '#B81412',
                                    }
                                },
                                classes: {
                                    base: 'form-control h-auto',
                                    complete: 'is-valid',
                                    invalid: 'bg-alert-danger border-none',
                                    empty: ''
                                },
                                iconStyle: 'default',
                                supportedCountries: ['SEPA'],
                                placeholderCountry: 'FR',
                            }}
                        />
                    </div>
                :
                    <div className="form-row gy-1">
                        <div className="col-lg-2 form-group">
                            <label className="h6 font-weight-bolder my-auto" htmlFor="date">Pays</label>
                            <input type="text" className="form-control h-auto" value={paymentMethod.country} disabled />
                        </div>
                        <div className="col form-group">
                            <label className="h6 font-weight-bolder my-auto" htmlFor="date">Code banque</label>
                            <input type="text" className="form-control h-auto" value={paymentMethod.bankCode} disabled />
                        </div>
                        <div className="col form-group">
                            <label className="h6 font-weight-bolder my-auto" htmlFor="date">4 derniers caractères</label>
                            <input type="text" className="form-control h-auto" value={paymentMethod.iban} disabled />
                        </div>
                    </div>
            }
            
        </form>
    )
}